/**
 * Created by Reda on 28.04.2025
 */

const TwoTabsWindow = CleverappsWindow.extend({
    ctor: function () {
        TwoTabsWindow.showed = true;

        cleverapps.metrics.logEvent(cleverapps.EVENTS.SYSTEM.TWO_TABS_WINDOW);

        this._super();

        this.setLocalZOrder(Transition.ZORDER + 1);
    },

    onWindowLoaded: function () {
        this._super({
            name: "TwoTabsWindow",
            title: Messages.get("TwoTabsWindow.Attention"),
            content: this.createContent(),
            button: {
                text: Messages.get("TwoTabsWindow.Reload"),
                width: cleverapps.styles.TwoTabsWindow.button.width,
                height: cleverapps.styles.TwoTabsWindow.button.height,
                onPressed: function () {
                    connector.platform.locationReload();
                }
            },
            closeButton: false
        });
    },

    onClose: function () {
        connector.platform.locationReload();
    },

    createContent: function () {
        const message = "TwoTabsWindow.CannotPlayInTwoTabs";

        const text = cleverapps.UI.generateOnlyText(Messages.get(message), cleverapps.styles.FONTS.TWO_TABS_WINDOW_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER);

        const illustration = new cc.Sprite(bundles.two_tabs_window.urls.illustration);

        return new cleverapps.Layout([illustration, text], {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.TwoTabsWindow.margin
        });
    },

    listBundles: function () {
        return ["two_tabs_window"];
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TWO_TABS_WINDOW_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.TwoTabsWindow = {
    width: 590,
    height: 460,
    margin: 30,
    button: {
    }
};